import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

export default function ProfileUpdate() {
    const navigate = useNavigate();
    const [user, setUser] = useState({
        username: "",
        email: "",
        mobile_number: ""
    });

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchProfile() {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/profile`, {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("text2sql_authToken")}`
                    }
                });
                if (res.status === 401) {
                    localStorage.removeItem('text2sql_authToken');
                    localStorage.removeItem('text2sql_user');
                    navigate("/login");
                    return;
                }
                const data = await res.json();
                if (!res.ok) throw new Error(data.message || "Not authenticated");

                // backend returns: { success, user }
                setUser({
                    username: data.data.username || "",
                    email: data.data.email || "",
                    mobile_number: data.data.mobile_number || ""
                });

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        }

        fetchProfile();
    }, []);

    async function handleSave(e) {
        e.preventDefault();
        setSaving(true);

        try {
            const formData = new FormData();
            formData.append("username", user.username);
            formData.append("email", user.email);
            formData.append("mobile_number", user.mobile_number);

            const res = await fetch(`${process.env.REACT_APP_API_ROOT}/api/auth/profile`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("text2sql_authToken")}`
                    // ❌ DO NOT set Content-Type for FormData
                },
                body: formData
            });
            if (res.status === 401) {
                localStorage.removeItem('text2sql_authToken');
                localStorage.removeItem('text2sql_user');
                navigate("/login");
                return;
            }
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Update failed");

            navigate("/profile");

        } catch (err) {
            setError(err.message);
        } finally {
            setSaving(false);
        }
    }

    if (loading) return <div className="p-8 text-center">Loading...</div>;

    if (error) return (
        <div className="p-8 text-center">
            <p className="mb-4 text-red-600">{error}</p>
            <Link to="/login" className="text-indigo-600 underline">Sign in</Link>
        </div>
    );

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow">
                <h1 className="text-2xl font-semibold mb-4">Edit Profile</h1>

                <form onSubmit={handleSave} className="space-y-4">

                    {/* Username */}
                    <label className="block">
                        <span className="text-sm">Full Name</span>
                        <input
                            value={user.username}
                            onChange={(e) => setUser({ ...user, username: e.target.value })}
                            className="mt-1 w-full rounded-md border-gray-200 p-2"
                        />
                    </label>

                    {/* Email */}
                    <label className="block">
                        <span className="text-sm">Email</span>
                        <input
                            type="email"
                            value={user.email}
                            onChange={(e) => setUser({ ...user, email: e.target.value })}
                            className="mt-1 w-full rounded-md border-gray-200 p-2"
                        />
                    </label>

                    {/* Mobile Number */}
                    <label className="block">
                        <span className="text-sm">Mobile Number</span>
                        <input
                            type="text"
                            value={user.mobile_number}
                            onChange={(e) => setUser({ ...user, mobile_number: e.target.value })}
                            className="mt-1 w-full rounded-md border-gray-200 p-2"
                            placeholder="Enter mobile number"
                        />
                    </label>

                    <div className="flex gap-2">
                        <button
                            disabled={saving}
                            type="submit"
                            className="px-4 py-2 bg-indigo-600 text-white rounded"
                        >
                            {saving ? "Saving..." : "Save"}
                        </button>

                        <Link to="/profile" className="px-4 py-2 bg-gray-100 rounded">
                            Cancel
                        </Link>
                    </div>

                </form>
            </div>
        </div>
    );
}
